
export default {
    picking: false,
    pickingForLeadGen: null
}


// WEBPACK FOOTER //
// ./public/pages/LeadGenFieldPicker/initialState.js